import { JudicialResultListView } from '@/components/templates/JudicialResultListView/JudicialResultListView'

import { useJudicialResultListPage } from './useJudicialResultListPage'

export const JudicialResultListPage = () => {
  const props = useJudicialResultListPage()
  return <JudicialResultListView {...props} />
}
